module.exports = __webpack_public_path__ + "img/avatar-tag.1a7009c9.png";